import directus from "api/services/directus";
import { DeliveryCities } from "custom-types/Directus";
import logError from "utils/logError";

const getDeliveryCities = async (countryCode = "US", slug?: string | null) => {
  const params = {
    "filter[country][_eq]": countryCode,
    "filter[slug][_eq]": slug ? slug : null,
    "filter[status][_in]": "published",
  };

  try {
    const { data } = await directus.get<DeliveryCities[]>("delivery_cities", {
      params: params,
    });

    return (data.length && data[0]) || {};
  } catch (e) {
    logError(e.message, {
      functionName: "getDeliveryCities",
      service: "directus",
      statusCode: e.statusCode,
    });

    return {};
  }
};

export default getDeliveryCities;
